import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import MenuBar from "./MenuBar";
import { VpnKey, DataUsage, Group } from "@material-ui/icons";
import AdminHeader from "./AdminHeader";
import "./Admin.css";
import { useStyles } from "./AdminStyles";
import ErrorBoundary from "../../data/ErrorBoundary";
import DefaultLoader from "../../components/DefaultLoader";

const menuItems = [
  {
    id: 1,
    componentName: "DynamicKeys",
    title: "Dynamic Keys-Value Configuration Manager",
    description: "Manage key-value configuration parameters",
    status: "Active",
    icon: <VpnKey />,
  },
];

const Admin = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [ComponentToRender, setComponentToRender] = useState("");
  const [currentSelected, setCurrentSelected] = useState(menuItems[0]);

  const handleToggle = useCallback(() => {
    setOpen((prevValue) => !prevValue);
  }, []);

  useEffect(() => {
    let Component = null;
    Component = lazy(() =>
      import(`./${currentSelected.componentName}`).catch(() => ({
        default: () => (
          <ErrorBoundary>
            <div className={classes.ModuleNotFound}>Module Does Not exist</div>
          </ErrorBoundary>
        ),
      }))
    );
    if (Component) {
      setComponentToRender(Component);
    }
  }, [currentSelected]);
  return (
    <div className={classes.adminLayout}>
      <MenuBar
        open={open}
        setOpen={handleToggle}
        menuItems={menuItems}
        currentSelected={currentSelected}
        setCurrentSelected={setCurrentSelected}
      />
      <main
        className={classes.adminMain}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <AdminHeader
          handleToggle={handleToggle}
          currentSelected={currentSelected}
        />
        <div style={{ flex: "1 1 auto", overflow: "hidden", minHeight: 0 }}>
          <Suspense
            fallback={
              <DefaultLoader displayModal={true} message="Loading...." />
            }
          >
            {ComponentToRender ? <ComponentToRender /> : ""}
          </Suspense>
        </div>
      </main>
    </div>
  );
};

export default Admin;
